import {
    OutdoorConditionsActions,
    OutdoorConditionsState,
} from 'redux/types/outdoorConditionsActionModel';
import * as actionTypes from '../actionTypes';

const initialState: OutdoorConditionsState = {
    isLoading: false,
    payload: null,
    error: null,
};

export const outdoorConditionsReducer = (
    state = initialState,
    action: OutdoorConditionsActions,
): OutdoorConditionsState => {
    switch (action.type) {
        case actionTypes.FETCH_OUTDOOR_CONDITIONS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actionTypes.FETCH_OUTDOOR_CONDITIONS_SUCCESS:
            return {
                isLoading: false,
                payload: action.payload,
                error: null,
            };
        case actionTypes.FETCH_OUTDOOR_CONDITIONS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };
        default:
            return state;
    }
};
